import { Skeleton } from '../Skeleton';

import Option from './Option';

const OptionSkeleton = () => (
  <Option>
    <Skeleton width='100%' />
  </Option>
);

export default OptionSkeleton;
